import { SVGInterface } from "../../interface";

const LineDown = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M13.707 9.29297C13.4418 9.29303 13.1875 9.39842 13 9.58597L9.99997 12.586L3.70697 6.29297L2.29297 7.70697L8.99997 14.414C9.18746 14.6015 9.44177 14.7069 9.70697 14.707H10.293C10.5582 14.7069 10.8125 14.6015 11 14.414L14 11.414L18.293 15.707L16 18H22V12L19.707 14.293L15 9.58597C14.8125 9.39842 14.5582 9.29303 14.293 9.29297H13.707Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default LineDown;
